<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <hazard-class-create-or-update v-model="hazard" :errors="errors"></hazard-class-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :buttons="buttons"
                    :add-callback="createNew"
                    :fields="fields"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import HazardApi from '@/api/hazard-class'
import HazardClassCreateOrUpdate from './components/HazardClassCreateOrUpdate.vue';

export default{
    components:{
        BCard,
        HazardClassCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:'İsim',key:'ClassName',thClass:'w-25'},
                {name:'Kategori',key:'CategoryName',thClass:'w-25'},
                {name:'Eğitim Saati',key:'EducationHours',thClass:'w-25'},
                {name:'Yenileme Süresi (Yıl)',key:'RenewalPeriodYears',thClass:'w-25'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            errors:{},
            hazard:{
                Id: null,
                Name: null,
                Category: null,
                EducationHours: null,
                RenewalPeriodYears: null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.hazard.Id = null
            this.hazard.Name = null
            this.hazard.Category = null
            this.hazard.EducationHours = null
            this.hazard.RenewalPeriodYears = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HazardApi.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.hazard.Id = item.Id
            this.hazard.Name = item.ClassId
            this.hazard.Category = item.CategoryId
            this.hazard.EducationHours = item.EducationHours
            this.hazard.RenewalPeriodYears = item.RenewalPeriodYears
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HazardApi.CreateOrUpdate(this.editing,this.hazard).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli tehlike sınıfını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HazardApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>